"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHomeTranslate = void 0;
exports.defaultHomeTranslate = {
    featureTitle: 'Find Your Home in Hong Kong',
    forSale: 'For Sale',
    forRent: 'For Rent',
    head: 'Hong Kong\'s Trusted Property Agency',
    caption: 'OKAY.com has the most up-to-date listings and responsive property agents to help you find your next home or property investment.',
    soleAgencyTitle: 'Featured Properties For Rent & Sale',
    testimonialTitle: 'What Our Clients Say',
    viewMoreReview: 'View More Reviews',
    uniqueListings: 'Unique Property Listings',
    updatedWithin: 'Updated within 90 days',
    newListingThisWeek: 'New Listings this week',
    calcHead: 'What Can I Afford',
    calcDownpayment: 'Down Payment',
    calcMonthly: 'Monthly Payment',
    calcDuration: 'Loan Duration',
    calcRate: 'Interest Rate %',
    viewProperties: 'View {} Properties',
    newsTitle: 'Insights, Analysis and Property News',
    more: 'More',
    fgp: 'Forbes Global Properties',
    fgpTitle: 'Founding Member of Forbes Global Properties',
    readMoreNews: 'Read More News & Articles',
    viewFullReview: 'View full testimonial',
    searchPlaceholder: 'Search Property, building name or loaction',
    news: 'News',
    insights: 'Insights',
    articles: 'Articles',
    buildings: 'Buildings',
    locations: 'Locations',
    districts: 'Districts',
    estates: 'Estates',
    phases: 'Phases',
    roads: 'Roads',
    estimatedMaximumPropertyValueLabel: 'Estimated Maximum Property Value Based on Mortgage Assumptions',
};
